import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { IonicModule } from "@ionic/angular";
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, CarouselModule, IonicModule]
})
export class WelcomePage implements OnInit {

  private auth = inject(AuthService)

  slides = [
    {
      image: "/assets/welcome/1.png",
    },
    {
      image: "/assets/welcome/2.png",
    },
    {
      image: "/assets/welcome/3.png",
    },
    {
      image: "/assets/welcome/4.png",
    },
    {
      image: "/assets/welcome/5.png",
    },
    {
      image: "/assets/welcome/6.png",
    }
  ]
  constructor(
    private modalController: ModalController
  ) { }

  end = false

  ngOnInit() {
  }

  async next(e: any,c: Carousel) {
    
    if(this.end) {
      this.modalController.dismiss()
      return
    }
    
    c.navForward(e)
    console.log(c.page, e)
    if(c.page == this.slides.length-1) {
      // reached end
      this.end = true
      await this.auth.setWelcomeShown()
    } else {
      this.end = false
    }
  }

}
